var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.734 14.587 9.5 18.352l6.852-6.853-3.765-3.766-6.852 6.853zm-2.74-2.398a3.392 3.392 0 0 0 0 4.796l2.464 2.464-.058.059 5.824 5.824.054-.054 2.435 2.435a3.392 3.392 0 0 0 4.797 0l10.497-10.497a3.392 3.392 0 0 0 0-4.797l-4.108-4.106a3.392 3.392 0 0 0-4.797 0l-.901.9a3.46 3.46 0 0 0-.11-.113l-4.106-4.107a3.392 3.392 0 0 0-4.797 0L2.992 12.19zm13.36 5.012-4.007 4.007 3.764 3.764 4.01-4.008-3.765-3.764zm6.335 1.194-3.766-3.764 3.577-3.577 3.765 3.765-3.576 3.576z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerp);
export default __webpack_public_path__ + "static/media/PERP.e6f021fee750565604cffd3dd07efaf4.svg";
export { ForwardRef as ReactComponent };